module.exports = __webpack_public_path__ + "gw.svg?6cff1be1e4c69c07d8cf16416e6ed22f";


//////////////////
// WEBPACK FOOTER
// ./src/images/flags/1x1/gw.svg
// module id = 826
// module chunks = 27